/* @flow */
import React from 'react';

import AuthActions from 'auth/AuthActions';
import LoadingIndicator from 'components/LoadingIndicator.jsx';

import AuthenticationView from 'auth/components/AuthenticationView.jsx';


class SignOutPage extends React.Component {
  static onEnter = () => {
    AuthActions.signOut(); // This will redirect after sign out is complete
  };

  render() {
    return (
      <AuthenticationView {...this.props} className="SignOutPage">
        <LoadingIndicator />
      </AuthenticationView>
    );
  }
}

export default SignOutPage;



// WEBPACK FOOTER //
// ./src/auth/components/SignOutPage.jsx